module.exports = "#version 300 es\r\nprecision highp float;\r\n\r\nuniform mat4 u_Model;\r\n\r\nin vec4 fs_Col;\r\nin vec4 fs_Pos;\r\nin vec2 fs_UV;\r\n\r\nlayout(location = 0) out vec4 out_Color;\r\n\r\n\r\nvoid main()\r\n{  \r\n   if(fs_Col.w > 0.0)\r\n     out_Color = u_Model * fs_Col;\r\n   else\r\n     out_Color = fs_Col;\r\n}\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/shaders/objInfo-frag.glsl
// module id = 75
// module chunks = 0